import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeView: "listening",
  chartTitle: "",
  /** 'en' | 'es' — errores/aviso parcial Sharma; default inglés hasta petición explícita de español */
  conversationLocale: "en",
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setActiveView: (state, { payload }) => {
      state.activeView = payload; // 'listening' | 'chart'
    },
    toggleView: (state) => {
      state.activeView = state.activeView === "listening" ? "chart" : "listening";
    },
    setChartTitle: (state, { payload }) => {
      state.chartTitle = payload;
    },
    setConversationLocale: (state, { payload }) => {
      state.conversationLocale = payload === "es" ? "es" : "en";
    },
  },
});

export const { setActiveView, toggleView, setChartTitle, setConversationLocale } =
  uiSlice.actions;
export default uiSlice.reducer;
